import { Injectable } from '@angular/core';

export const VERSION_CHECK_TIMEOUT_MS = 5000;

@Injectable({
  providedIn: 'root',
})
export class DeployedVersionService {
  async getLiveVersion(): Promise<string | null> {
    try {
      const response = await fetch('/index.html', {
        method: 'HEAD',
        cache: 'no-store',
        signal: AbortSignal.timeout(VERSION_CHECK_TIMEOUT_MS),
      });
      return (response.ok && response.headers.get('X-Ninety-Version')) || null;
    } catch {
      return null;
    }
  }
}
